<template lang="pug">
div
  el-table(:data='tableData', style='width: 100%', max-height='500')
    el-table-column(label='id', width='100')
      template(slot-scope='scope')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'ja' }}")
          | {{scope.row.entry_id}}
    el-table-column(label='タイトル', width='400')
      template(slot-scope='scope')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'ja' }}")
          | {{scope.row.title}}
    el-table-column(label='種別', width='150' v-if='apiname==="top_layer"')
      template(slot-scope='scope')
        | {{layerTypes[scope.row.layer_type]}}
    el-table-column(prop='category', label='カテゴリー', width='200', v-if='apiname==="news" || apiname==="faq" || apiname==="work"')
    el-table-column(label='J/E/C/K', width='150')
      template(slot-scope='scope')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'ja' }}")
          img(:src="'/static/img/language_icon/indicate-' + scope.row.locale.ja + '.gif'", alt='')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'en' }}")
          img(:src="'/static/img/language_icon/indicate-' + scope.row.locale.en + '.gif'", alt='')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'cn' }}")
          img(:src="'/static/img/language_icon/indicate-' + scope.row.locale.cn + '.gif'", alt='')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'kr' }}")
          img(:src="'/static/img/language_icon/indicate-' + scope.row.locale.kr + '.gif'", alt='')
    el-table-column(label='登録日', width='200')
      template(slot-scope='scope')
        | {{scope.row.created_at | moment}}
    el-table-column(label='更新日', width='200')
      template(slot-scope='scope')
        | {{scope.row.updated_at | moment}}
    el-table-column(fixed='right', label='Operations', width='200')
      template(slot-scope='scope')
        el-button(v-if='apiname==="overview" || apiname==="feature" || apiname==="faq" || apiname==="techinfo"', size='mini', type='primary', icon='el-icon-caret-top', @click='moveListUp(scope.$index)')
        el-button(v-if='apiname==="overview" || apiname==="feature" || apiname==="faq" || apiname==="techinfo"', size='mini', type='primary', icon='el-icon-caret-bottom', @click='moveListDown(scope.$index)')
        el-button(v-if='apiname!="top"' , size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index, tableData)', :disabled='!scope.row.deletable')
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data () {
    return {
      tableData: [],
      dummy: {
        locale: {
          ja: 'open',
          en: 'close',
          cn: 'draft',
          kr: 'wait'
        }
      },
      layerTypes: {
        text: 'テキスト',
        image_white: '画像（背景白）',
        image_black: '画像（背景黒）',
        video: '動画'
      }
    }
  },
  props: {
    apiname: String,
    editPath: String
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm:ss')
    }
  },
  created () {
    this.getListData()
  },
  methods: {
    getListData () {
      return axios({
        method: 'get',
        url: '/admin/swan/' + this.apiname,
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        var _contents = res.data.contents
        this.tableData = _contents
      }).catch(function (error) {
        console.log(error)
      })
    },
    moveListUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.tableData.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.tableData[orgIndex])
        this.tableData = tmp
        this.sendOrder()
      }
    },
    moveListDown (orgIndex) {
      if (orgIndex < this.tableData.length) {
        let target = orgIndex + 1
        let tmp = this.tableData.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.tableData[orgIndex])
        this.tableData = tmp
        this.sendOrder()
      }
    },
    sendOrder () {
      let orders = []
      for (let i in this.tableData) {
        orders.push(this.tableData[i]['entry_id'])
      }
      console.log(orders)
      let inputData = JSON.stringify({
        page: this.apiname,
        orders: orders
      })
      return axios({
        method: 'post',
        url: '/admin/swan/change_order',
        baseURL: process.env.API_BASE_URL,
        data: {
          data: inputData
        }
      }).then((res) => {
        console.log('order change')
      }).catch(function (error) {
        console.log(error)
      })
    },
    deleteConfirm (index, rows) {
      this.$confirm(this.tableData[index].title + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        return axios({
          baseURL: process.env.API_BASE_URL,
          url: '/admin/swan/' + this.apiname + '/edit',
          method: 'DELETE',
          data: {
            entry_id: this.tableData[index].entry_id
          }
        })
      }).then(() => {
        rows.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/components/swan/common/List.vue